import { schema } from 'normalizr';

export type ClassType = {
  id: string;
  name: string;
};

export const toClassTypeSchema = (options: schema.EntityOptions = {}) =>
  new schema.Entity('classTypes', {}, options);
